module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0cef7883deeca23b0f70a19f9868899c.png";